import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useGetToken } from '../../config';

type TVariables = {
  token: string;
  id: string;
  includeBulkWastePrices?: boolean;
  includeAddContainerPrices?: boolean;
  priceForTicketTypeId?: string;
};

export const call = ({
  id,
  token,
  includeBulkWastePrices,
  includeAddContainerPrices,
  priceForTicketTypeId,
}: TVariables) =>
  axios.get(`property/${id}/ticket-prices`, {
    headers: {
      'X-API-Key': token,
    },
    params: {
      include_bulk_waste_prices: includeBulkWastePrices,
      include_add_container_prices: includeAddContainerPrices,
      price_for_ticket_type_id: priceForTicketTypeId,
    },
  });

const K_GET_PROPERTY_TICKET_PRICES = 'K_GET_PROPERTY_TICKET_PRICES';

export const useGetPropertyTicketPrices = (
  propertyId: string,
  params?: Partial<
    Pick<
      TVariables,
      | 'includeBulkWastePrices'
      | 'includeAddContainerPrices'
      | 'priceForTicketTypeId'
    >
  >
) => {
  const token = useGetToken();
  return useQuery<$TSFixMe>({
    queryKey: [K_GET_PROPERTY_TICKET_PRICES, propertyId, { ...params }],
    queryFn: () => call({ token, id: propertyId, ...params }),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
